window.addEventListener("load", () => {
  const searchInputContainer = document.getElementById(
    "sc-search-input-container",
  );
  const customSelect = document.getElementById("sc-custom-select");
  const display = document.getElementById("sc-selected-display");
  const optionsList = document.getElementById("sc-custom-options");
  if (!display) return;
  const arrow = display.querySelector("svg");

  const searchInput = document.getElementById("sc-search-input");
  const dynamicCards = document.getElementById("sc-dynamic-cards");
  const loader = document.getElementById("sc-loader");
  const loadMoreBtn = document.getElementById("sc-load-more-btn");
  const loadMoreContainer = document.getElementById("sc-load-more-container");

  let searchQuery = "";
  let selectedType = "";
  let currentPage = 1;
  const perPage = 8;

  searchInputContainer.addEventListener("click", () => {
    document.getElementById("sc-search-input").focus();
  });

  display.addEventListener("click", () => {
    optionsList.classList.toggle("hidden");
    arrow.classList.toggle("rotate-180");
  });

  optionsList.querySelectorAll("li").forEach((li) => {
    li.addEventListener("click", () => {
      const val = li.getAttribute("data-value");
      const text = li.textContent.trim();

      display.querySelector(".selected-text").textContent = text;

      selectedType = val;
      fetchData();

      optionsList.classList.add("hidden");
      arrow.classList.remove("rotate-180");
    });
  });

  document.addEventListener("click", (e) => {
    if (!customSelect.contains(e.target)) {
      optionsList.classList.add("hidden");
      arrow.classList.remove("rotate-180");
    }
  });

  function showLoader() {
    loader.classList.remove("hidden");
  }
  function hideLoader() {
    loader.classList.add("hidden");
  }

  function formatDeadline(doc) {
    const hours = Math.floor(doc?.deadline_time / 3600);
    const minutes = Math.floor((doc?.deadline_time % 3600) / 60);
    const suffix = hours >= 12 ? "p.m." : "a.m.";
    const displayHour = hours % 12 || 12;
    const displayMinutes = String(minutes).padStart(2, "0");
    const dateObj = new Date(doc?.deadline_date * 1000);
    if (isNaN(dateObj.getTime())) {
      return doc?.deadline_label || "";
    }
    const datePart = dateObj.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });

    return `${displayHour}:${displayMinutes} ${suffix} ET on ${datePart}`;
  }

  function resolveLoginGate(url, title, n) {
    if (n?.enable_login_gate && !envConfig.IS_USER_LOGGED_IN) {
      return {
        url: `${envConfig.LOGIN_PAGE_URL}?redirect_to=${encodeURIComponent(window.location.href)}`,
        title: n?.login_button_text || "Login to View",
      };
    }
    return { url, title };
  }

  function generateHtml(n) {
    const deadlineDatePart = formatDeadline(n);

    return `
    <div class="px-5 py-12 lg:px-12 bg-white flex flex-col gap-6">
      <div class="flex justify-between items-center max-sm:flex-col-reverse gap-6">
        ${n?.title ? `<h2 class="w-full text-brand-dark-red font-josefin text-h2 max-sm:text-center">${n.title}</h2>` : ""}
        ${n?.featured_image ? `<img src="${n.featured_image}" alt="card-image" class="max-w-[14.8125rem] h-[4.6875rem] w-full object-contain" />` : ""}
      </div>

      <div class="h-[.0625rem] w-full bg-brand-warm-beige"></div>

      ${n?.description ? `<div class="richText text-brand-black text-[1.5625rem] leading-[2.0625rem] max-sm:text-center">${n.description}</div>` : ""}

      ${
        deadlineDatePart || n?.link_title
          ? `
      <div class="flex gap-6 sm:gap-8 items-center max-sm:flex-col">
        ${
          n?.link_title && n?.link_url
            ? (() => {
                const resolved = resolveLoginGate(n.link_url, n.link_title, n);
                return `
          <a href="${resolved.url}" class="brand-warm-beige-filled-with-right-icon-bpa-btn bpa-button">
            ${resolved.title}
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" width="10" height="17" viewBox="0 0 10 17" fill="none">
              <path d="M0.5 0.5L8.80189 8.5L0.5 16.5" stroke="white" stroke-linecap="round" />
            </svg>
          </a>
        `;
              })()
            : ""
        }
        
        ${n?.link_title && deadlineDatePart ? `<div class="w-full h-[.0625rem] sm:w-[.0625rem] sm:h-auto sm:self-stretch bg-brand-warm-beige shrink-0"></div>` : ""}

        ${
          deadlineDatePart
            ? `
          <p class="max-sm:text-center text-brand-dark-blue text-[1.5625rem] leading-[2.0625rem]">
            ${n?.deadline_label ? `<span>${n.deadline_label} </span>` : ""}
            <span class="font-semibold">${deadlineDatePart}</span>
          </p>
        `
            : ""
        }
      </div>
      `
          : ""
      }
    </div>
  `;
  }

  async function fetchData(append = false) {
    if (!append) {
      currentPage = 1;
      dynamicCards.innerHTML = "";
    }

    showLoader();
    loadMoreContainer.classList.add("hidden");

    const params = {
      q: searchQuery.length > 0 ? searchQuery : "*",
      query_by: "title,description",
      sort_by: "title:asc",
      per_page: perPage,
      page: currentPage,
    };

    if (selectedType) params.filter_by = `benefactor_slugs:=[${selectedType}]`;

    try {
      const url =
        `${envConfig.TYPESENSE_BASE_URL}:${envConfig.TYPESENSE_PORT}/collections/scholarships/documents/search?` +
        new URLSearchParams(params);
      const response = await fetch(url, {
        headers: { "X-TYPESENSE-API-KEY": envConfig.TYPESENSE_SEARCH_ONLY_KEY },
      });
      const data = await response.json();

      updateUIState(data.found || 0);

      if (data?.hits?.length > 0) {
        const newHtml = data?.hits
          ?.map((hit) => generateHtml(hit?.document))
          ?.join("");
        dynamicCards.insertAdjacentHTML("beforeend", newHtml);

        if (data.found > currentPage * perPage) {
          loadMoreContainer.classList.remove("hidden");
        }
      } else if (!append) {
        dynamicCards.innerHTML = `<div class="text-center pt-10 text-brand-black text-[1.25rem] leading-[1.5625rem]">No results found.</div>`;
      }
    } catch (error) {
      console.error("Typesense Error:", error);
    } finally {
      hideLoader();
    }
  }

  loadMoreBtn.addEventListener("click", () => {
    currentPage++;
    fetchData(true);
  });

  const debounce = (fn, delay) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  };

  searchInput.addEventListener(
    "input",
    debounce((e) => {
      searchQuery = e.target.value.trim();
      fetchData();
    }, 300),
  );

  if (!searchQuery) {
    fetchData();
  }

  //  PILLS AND CLEAR FILTERS
  const activeFiltersContainer = document.getElementById("sc-active-filters");
  const pillsContainer = document.getElementById("sc-pills-container");
  const resultsCountDisplay = document.getElementById("sc-results-count");
  const clearAllBtn = document.getElementById("sc-clear-all");

  function updateUIState(totalResults) {
    pillsContainer.innerHTML = "";

    if (searchQuery || selectedType) {
      activeFiltersContainer.classList.remove("hidden");
      resultsCountDisplay.classList.remove("hidden");
      resultsCountDisplay.textContent = `${totalResults} ${totalResults === 1 ? "Result" : "Results"}`;
    } else {
      activeFiltersContainer.classList.add("hidden");
      resultsCountDisplay.classList.add("hidden");
      return;
    }

    if (searchQuery) {
      createPill(searchQuery, () => {
        searchQuery = "";
        searchInput.value = "";
        fetchData();
      });
    }

    if (selectedType) {
      const selectedLabel =
        document
          .querySelector(`li[data-value="${selectedType}"]`)
          ?.textContent.trim() || selectedType;
      createPill(selectedLabel, () => {
        selectedType = "";
        display.querySelector(".selected-text").textContent =
          "Filter by Benefactor";
        fetchData();
      });
    }
  }

  function createPill(text, onRemove) {
    const pill = document.createElement("div");
    pill.className =
      "pr-2 pl-5 py-2 bg-brand-dark-red gap-[.625rem] flex justify-center items-center w-fit rounded-[3.125rem]";
    pill.innerHTML = `
      <span class="text-[1.25rem] leading-[1.5625rem] font-normal text-white">${text}</span>
      <svg class="cursor-pointer overflow-visible remove-pill" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <circle cx="12.5" cy="12.5" r="12.5" fill="white" />
        <path d="M17.042 17.9748L7.31931 8.25208C7.07535 8.00812 7.08683 7.60067 7.34493 7.34257L17.9772 17.0397L17.042 17.9748Z" fill="#A72B2A" />
        <path d="M18.2873 8.27048L8.56458 17.9932L18.2873 8.27048Z" fill="#A72B2A" />
        <path d="M17.5 7.5L7.5 17.5M7.5 7.5L17.5 17.5" stroke="#A72B2A" stroke-width="2" stroke-linecap="round"/>
      </svg>
    `;
    pill.querySelector(".remove-pill").addEventListener("click", onRemove);
    pillsContainer.appendChild(pill);
  }

  clearAllBtn.addEventListener("click", () => {
    searchQuery = "";
    selectedType = "";
    searchInput.value = "";
    display.querySelector(".selected-text").textContent =
      "Filter by Benefactor";
    activeFiltersContainer.classList.add("hidden");
    resultsCountDisplay.classList.add("hidden");
    pillsContainer.innerHTML = "";
    fetchData();
  });
});
